<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<p class="C333" id="page_x">
<strong>CHRONOLOGY</strong>
</p>
<div class="table">
<table class="C396" style="width:100%;">
<tr class="T316_FirstRow">
<td class="C398" style="vertical-align:top;">11 September 1885</td>
<td class="C399" style="vertical-align:top;">
<p class="jus">Born in Eastwood, Nottinghamshire</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">September 1898–July 1901</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Pupil at Nottingham High School</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">1902–1908</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Pupil teacher; student at University College, Nottingham</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">7 December 1907</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">First publication: 'A Prelude', in <em>Nottinghamshire Guardian</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">October 1908</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Appointed as teacher at Davidson Road School, Croydon</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">November 1909</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Publishes five poems in <em>English Review</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">3 December 1910</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Engagement to Louie Burrows; broken off on 4 February 1912</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">9 December 1910</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Death of his mother, Lydia Lawrence</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">19 January 1911</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The White Peacock</em> published in New York (20 January in London)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">19 November 1911</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Ill with pneumonia; resigns his teaching post on 28 February 1912</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">March 1912</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Meets Frieda Weekley; they elope to Germany on 3 May</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">23 May 1912</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Trespasser</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">September 1912–March 1913</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">At Gargnano, Lago di Garda, Italy</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">February 1913</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Love Poems and Others</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">29 May 1913</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Sons and Lovers</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">June–August 1913</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In England</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">August 1913–June 1914</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In Germany, Switzerland and Italy</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">1 April 1914</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Widowing of Mrs. Holroyd</em> (New York)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">July 1914–December 1915</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In London, Buckinghamshire and Sussex</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">13 July 1914</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Marries Frieda Weekley in London</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">26 November 1914</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Prussian Officer and Other Stories</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">30 September 1915</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Rainbow;</em> suppressed by court order on 13 November</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">June 1916</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Twilight in Italy</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">July 1916</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Amores</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">15 October 1917</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">After twenty-one months' residence in Cornwall, ordered to leave by military authorities</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">
<a id="page_xi">
</a>October 1917–November 1919</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In London, Berkshire and Derbyshire</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">26 November 1917</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Look! We Have Come Through!</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">October 1918</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>New Poems</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">20 November 1919</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Bay</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">November 1919–7 March 1920</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">To Italy, and then Capri</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">8 March 1920</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">At Fontana Vecchia, Taormina, Sicily</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">May 1920</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Touch and Go</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">9 November 1920</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Private publication of <em>Women in Love</em> (New York)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">25 November 1920</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Lost Girl</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">4–5 January 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Travel from Taormina to Palermo</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">5–13 January 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Sardinia: visit Cagliari, Mandas, Sorgono, Nuoro, Terranova; return to Sicily via Rome and Naples</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">by 21 January 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Begins writing 'Diary of a Trip to Sardinia' <em>(Sea and Sardinia)</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">
<em>c</em>. 27 January 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Visited by Jan Juta</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">February 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Movements in European History</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">12 February 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">The 'Diary' 'nearly done'</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">22 February 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">'I have finished the "Diary of a Trip to Sardinia"'</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">by 22 February 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">MS sent to Ruth Wheelock for typing</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">March 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Revises typescripts</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">by 22 March 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Last portion of TSS received</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">28 March 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Sends revised TSS to Robert Mountsier and to Barbara Low</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">27 April–10 July 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Hotel Krone, Ebersteinberg, Baden-Baden</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">May 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Juta in Sardinia painting illustrations for the 'Diary'</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">10 May 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Psychoanalysis and the Unconscious</em> (New York)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">1 June 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Finishes <em>Aaron's Rod;</em> begins <em>Fantasia of the Unconscious</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">
<em>c</em>. 10 June 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Women in Love</em> published in England by Secker</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">23 June 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Receives five of Juta's eight pictures</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">by 4 July 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Has received remaining three pictures from Juta</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">5<em>–c</em>. 27 July 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Mountsier visits Lawrences</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">10–19 July 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">To Zell-am-See via Austria</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">20 July–25 August 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">At Villa Alpensee, Zell-am-See</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">by 30 July 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Title <em>Sea and Sardinia</em> decided</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">25 August–19 September 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">At 32 Via dei Bardi, Florence</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">20–7 September 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Siena, Rome, Capri</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">
<a id="page_xii">
</a>28 September 1921–20 February 1922</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">At Fontana Vecchia</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">20 October 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Seltzer sends galley proofs of <em>Sea and Sardinia</em> to Mabel Mountsier for correction</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">October and November 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Extracts from <em>Sea and Sardinia</em> in the <em>Dial</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">12 December 1921</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Sea and Sardinia</em> published in the USA by Seltzer</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">March–August 1922</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In Ceylon and Australia</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">14 April 1022</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Aaron's Rod</em> (New York)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">September 1922–March 1923</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In New Mexico</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">23 October 1922</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Fantasia of the Unconscious</em> (New York)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">24 October 1922</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>England, My England</em> (New York)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">by 22 March 1923</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Ladybird, The Fox, The Captain's Doll</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">March–November 1923</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In Mexico and USA</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">April 1923</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Sea and Sardinia</em> published by Secker</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">27 August 1923</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Studies in Classic American Literature</em> (New York)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">September 1923</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Kangaroo</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">9 October 1923</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Birds, Beasts and Flowers</em> (New York)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">December 1923–March 1924</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In England, France and Germany</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">March 1924–September 1925</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In New Mexico and Mexico</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">28 August 1924</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Boy in the Bush</em> (with M. L. Skinner)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">10 September 1924</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Death of his father, John Arthur Lawrence</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">14 May 1925</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>St. Mawr together with The Princess</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">September 1925–June 1928</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In England and, mainly, in Italy</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">7 December 1925</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Reflections on the Death of a Porcupine</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">21 January 1926</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">(Philadelphia) <em>The Plumed Serpent</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">25 March 1926</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>David</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">June 1927</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Mornings in Mexico</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">24 May 1928</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Woman Who Rode Away and Other Stories</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">June 1928–March 1930</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">In Switzerland and, principally, in France</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">July 1928</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Lady Chatterley's Lover</em> privately published (Florence)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">September 1928</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>Collected Poems</em>
</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">July 1929</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Exhibition of paintings in London raided by police; <em>Pansies</em> (manuscript earlier seized in the mail)</p>
</td>
</tr>
<tr class="T316_Row">
<td class="C397" style="vertical-align:top;">September 1929</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">
<em>The Escaped Cock</em> (Paris)</p>
</td>
</tr>
<tr class="T316_LastRow">
<td class="C397" style="vertical-align:top;">2 March 1930</td>
<td class="C3977" style="vertical-align:top;">
<p class="jus">Dies at Vence, Alpes Maritime, France</p>
</td>
</tr>
</table>
</div>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Chronology.vue?29e7c25d